import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { logout } from "../store/authSlice";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const LogoutModal = ({ isOpen, onClose }) => {
  const userData = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleLogout = async () => {
    setLoading(true);

    const username = userData?.username || sessionStorage.getItem("username");

    if (!username) {
      console.error(
        "User data is missing or invalid. Cannot proceed with logout."
      );
      setLoading(false);
      return;
    }

    const payload = { username };

    try {
      const response = await axiosPostApi(apiList.LOGOUT, payload);
      if (response?.status === 200) {
        navigate("/auth/login");
        sessionStorage.clear();
        dispatch(logout());
        setLoading(false);
      } else {
        if (
          response.data.respCode === "01" ||
          response.data.respCode === "03"
        ) {
          CustomAlert({
            title: "Data Submission Error",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl shadow-lg w-[469px] p-6 relative">
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="leftImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />
        <div className="flex justify-center items-center">
          <div className="!bg-[#ff702b] p-3 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              className="w-[30px] h-[30px]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m0-9V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2v-1"
              />
            </svg>
          </div>
        </div>
        <div className="mt-6 text-center">
          <h2 className="text-2xl font-medium text-[#212529]">
            You will be logged out!
          </h2>
          <p className="text-[#495057] mt-6">
            Are you sure you want to Logout?
          </p>
        </div>
        <div className="flex items-center justify-center mt-6">
          <button
            onClick={onClose}
            className="btn btn-back w-[133px] py-2 !rounded-lg z-10"
          >
            Cancel
          </button>
          <button
            onClick={() => handleLogout()}
            className={`w-[133px] mx-2 py-2 !bg-[#ff702b] text-white !rounded-lg ${
              loading
                ? "opacity-50 cursor-not-allowed flex items-center justify-center gap-2"
                : ""
            }`}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size="20px" sx={{ color: "#FFF" }} />
            ) : (
              "Logout"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
